import {
  filter,
  isObservable,
  merge,
  Observable,
  of,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs';
import { POLYMORPHEUS_CONTEXT, PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { TuiButtonModule, TuiDialogCloseService, TuiScrollbarModule } from '@taiga-ui/core';
import { TuiDestroyService, TuiDialog } from '@taiga-ui/cdk';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
  Self,
} from '@angular/core';

import { DrawerOptions } from './drawer.config';
import { drawerToggle, slideInRight } from './drawer.animation';

function toObservable<T>(valueOrStream: Observable<T> | T): Observable<T> {
  return isObservable(valueOrStream) ? valueOrStream : of(valueOrStream);
}

@Component({
  selector: 'iss-drawer-container',
  standalone: true,
  templateUrl: './drawer-container.component.html',
  styleUrls: [ './drawer-container.component.scss' ],
  providers: [ TuiDestroyService, TuiDialogCloseService ],
  animations: [ drawerToggle, slideInRight ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PolymorpheusModule,
    TuiScrollbarModule,
    TuiButtonModule,
  ],
})
export class DrawerContainerComponent {
  @HostBinding('@issDrawerToggle')
  private readonly animation = true;

  public constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    public readonly context: TuiDialog<DrawerOptions, void>,
    @Inject(TuiDialogCloseService) close$: Observable<unknown>,
    @Self() @Inject(TuiDestroyService) destroy$: Observable<unknown>,
  ) {
    merge(this.context.closeService, close$)
      .pipe(
        switchMap(() => toObservable(context.closeable ?? true)),
        filter(Boolean),
        takeUntil(destroy$),
        tap(() => this.context.$implicit.complete()),
      )
      .subscribe();
  }
}
